import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';
import { APPLE_PAY } from '../../../../constants/paymentMethods';

import SvgComponent from '../../../SvgComponent';

import { ApplePayContainer } from './ApplePayStyle';

const ApplePay = ({ selectedMethod, handleMethodChange, i18n }) => {
    const [displayApplePay, setDisplayApplePay] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            const isWindows = /win/.test(navigator.userAgent.toLowerCase());
            setDisplayApplePay(isSafari && !isWindows);
        }
    }, []);

    return displayApplePay ? (
        <ApplePayContainer onClick={() => handleMethodChange(APPLE_PAY)}>
            <div>
                <input
                    type="radio"
                    id="apple-pay"
                    name="choix"
                    value={APPLE_PAY}
                    checked={selectedMethod === APPLE_PAY}
                />
                <label>{i18n.PAYMENT_CHOICE.APPLE_PAY}</label>
            </div>
            <SvgComponent src={`${STATIC_ROOT}/payment/apple-pay.svg`} widht={43} height={27} />
        </ApplePayContainer>
    ) : null;
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(ApplePay);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/ApplePay.js